export interface Testimonial {
  id: number;
  name: string;
  location: string;
  rating: number;
  text: string;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  // Featured reviews (shown on homepage)
  {
    id: 1,
    name: 'Alex M.',
    location: 'USA',
    rating: 5,
    text: 'Incredible quality! The hologram looks so realistic. Fast shipping too.',
    avatar: '/placeholder.svg',
  },
  {
    id: 2,
    name: 'Sophie L.',
    location: 'Germany',
    rating: 5,
    text: 'Perfect for my costume party. Everyone thought it was real!',
    avatar: '/placeholder.svg',
  },
  {
    id: 3,
    name: 'Marco R.',
    location: 'Italy',
    rating: 5,
    text: 'Great customer service and the card arrived in just 5 days.',
    avatar: '/placeholder.svg',
  },
  {
    id: 4,
    name: 'Elena K.',
    location: 'Russia',
    rating: 5,
    text: 'Exactly what I needed. The customization options are amazing.',
    avatar: '/placeholder.svg',
  },
  {
    id: 5,
    name: 'Carlos D.',
    location: 'Spain',
    rating: 5,
    text: 'Third order from this site. Never disappointed. Highly recommend!',
    avatar: '/placeholder.svg',
  },
];

// Extended reviews for the Reviews page
export const extendedReviews: Testimonial[] = [
  ...testimonials,
  // More 5-star reviews
  {
    id: 6,
    name: 'James T.',
    location: 'UK',
    rating: 5,
    text: 'Amazing quality and super fast delivery. The card looks absolutely authentic!',
    avatar: '/placeholder.svg',
  },
  {
    id: 7,
    name: 'Maurizio P.',
    location: 'Italy',
    rating: 5,
    text: 'Really the best! The product has excellent quality, would buy it again anytime!',
    avatar: '/placeholder.svg',
  },
  {
    id: 8,
    name: 'Miriam B.',
    location: 'Austria',
    rating: 5,
    text: 'Super friendly contact, responds fast to emails. I recommend this seller 100%!',
    avatar: '/placeholder.svg',
  },
  {
    id: 9,
    name: 'Noel Z.',
    location: 'Switzerland',
    rating: 5,
    text: 'ID cards look just like real ones! Got in everywhere, super satisfied!',
    avatar: '/placeholder.svg',
  },
  {
    id: 10,
    name: 'Océane W.',
    location: 'France',
    rating: 5,
    text: 'Impeccable! Had to wait a bit longer, but it was definitely worth it!',
    avatar: '/placeholder.svg',
  },
  {
    id: 11,
    name: 'Paul B.',
    location: 'Germany',
    rating: 5,
    text: 'Really great store. Card came within two days and looks amazing. Thank you!',
    avatar: '/placeholder.svg',
  },
  {
    id: 12,
    name: 'Sascha G.',
    location: 'Germany',
    rating: 5,
    text: 'I ordered two ID cards and the quality is just outstanding!',
    avatar: '/placeholder.svg',
  },
  {
    id: 13,
    name: 'Steven J.',
    location: 'USA',
    rating: 5,
    text: 'Good quality of the ID cards. Great communication. Fast shipping. Would order again!',
    avatar: '/placeholder.svg',
  },
  {
    id: 14,
    name: 'Edin A.',
    location: 'Bosnia',
    rating: 5,
    text: 'Very good ID card! Super quality and excellent communication!',
    avatar: '/placeholder.svg',
  },
  {
    id: 15,
    name: 'Edward D.',
    location: 'UK',
    rating: 5,
    text: 'Great quality of the cards! They look even better than in the pictures!',
    avatar: '/placeholder.svg',
  },
  {
    id: 16,
    name: 'Katrina B.',
    location: 'Latvia',
    rating: 5,
    text: 'The best you can buy online! Absolutely perfect quality.',
    avatar: '/placeholder.svg',
  },
  {
    id: 17,
    name: 'Laura N.',
    location: 'Netherlands',
    rating: 5,
    text: 'Everything went fine and fast. The ID card looks very real and helped me a lot!',
    avatar: '/placeholder.svg',
  },
  {
    id: 18,
    name: 'Lorenzo N.',
    location: 'Italy',
    rating: 5,
    text: 'I liked that I was able to go to places with my ID. I like how it looks, too!',
    avatar: '/placeholder.svg',
  },
  {
    id: 19,
    name: 'Luca S.',
    location: 'Switzerland',
    rating: 5,
    text: 'Great provider, fast delivery and good quality! Would recommend to everyone!',
    avatar: '/placeholder.svg',
  },
  {
    id: 20,
    name: 'Marleen H.',
    location: 'USA',
    rating: 5,
    text: 'Had a very good experience with the website! Everything worked out great.',
    avatar: '/placeholder.svg',
  },
  {
    id: 21,
    name: 'Sofia T.',
    location: 'Portugal',
    rating: 5,
    text: "I'm totally satisfied with the card I ordered - It looks completely real!",
    avatar: '/placeholder.svg',
  },
  {
    id: 22,
    name: 'Vlora V.',
    location: 'Kosovo',
    rating: 5,
    text: 'Very reputable! ID came after about a week and the hologram makes it look super real!',
    avatar: '/placeholder.svg',
  },
  {
    id: 23,
    name: 'Julian K.',
    location: 'Germany',
    rating: 5,
    text: 'Fast delivery, good quality! Exactly what I was looking for.',
    avatar: '/placeholder.svg',
  },
  {
    id: 24,
    name: 'Dari M.',
    location: 'Iran',
    rating: 5,
    text: 'Simply fast! Looks totally real! Top ID quality!',
    avatar: '/placeholder.svg',
  },
  {
    id: 25,
    name: 'Isabella F.',
    location: 'Argentina',
    rating: 5,
    text: 'Very satisfied! The card exceeded all my expectations.',
    avatar: '/placeholder.svg',
  },
  {
    id: 26,
    name: 'Lisa W.',
    location: 'USA',
    rating: 5,
    text: 'Easy ordering. Flexible with payment. Fast delivery to the US.',
    avatar: '/placeholder.svg',
  },
  {
    id: 27,
    name: 'Jan M.',
    location: 'Germany',
    rating: 5,
    text: 'Quality of the card is really great, even the hologram. Superior construction! Delivery was very fast.',
    avatar: '/placeholder.svg',
  },
  {
    id: 28,
    name: 'Asena T.',
    location: 'Turkey',
    rating: 5,
    text: 'Super fast shipment abroad. I am very satisfied with the product, totally happy!',
    avatar: '/placeholder.svg',
  },
  {
    id: 29,
    name: 'Ivan P.',
    location: 'Bulgaria',
    rating: 5,
    text: 'Very authentic card! I am totally satisfied and can only recommend this website.',
    avatar: '/placeholder.svg',
  },
  {
    id: 30,
    name: 'Patrick O.',
    location: 'Ireland',
    rating: 5,
    text: 'Very clean work! Professional quality all around.',
    avatar: '/placeholder.svg',
  },
  {
    id: 31,
    name: 'Kevin R.',
    location: 'Canada',
    rating: 5,
    text: "Just great! Fast delivery and very good item. Works without any problems. Can't ask for more!",
    avatar: '/placeholder.svg',
  },
  {
    id: 32,
    name: 'Tobias S.',
    location: 'Germany',
    rating: 5,
    text: 'At first I was skeptical. But I received the ID card fast and it looks real with the hologram, very professional.',
    avatar: '/placeholder.svg',
  },
  {
    id: 33,
    name: 'Fatos H.',
    location: 'Albania',
    rating: 5,
    text: 'Simply the best! Super quality, fast delivery and fair prices!',
    avatar: '/placeholder.svg',
  },
  {
    id: 34,
    name: 'Ann-Cathrin L.',
    location: 'USA',
    rating: 5,
    text: 'The ID looks totally real and delivery to the US took only 5 days. I can only recommend them!',
    avatar: '/placeholder.svg',
  },
  {
    id: 35,
    name: 'Lilith R.',
    location: 'Germany',
    rating: 5,
    text: "The card looks totally real, I'm thrilled! The order came fast and smooth, just after 2 days!",
    avatar: '/placeholder.svg',
  },
  {
    id: 36,
    name: 'Katharina W.',
    location: 'USA',
    rating: 5,
    text: 'Super fast shipping to the United States, thank you!!',
    avatar: '/placeholder.svg',
  },
  {
    id: 37,
    name: 'Peter H.',
    location: 'Netherlands',
    rating: 5,
    text: 'Fast delivery, easy settlement. Everything as it should be.',
    avatar: '/placeholder.svg',
  },
  {
    id: 38,
    name: 'Philipp M.',
    location: 'Austria',
    rating: 5,
    text: 'Fast delivery, very good quality! Top!',
    avatar: '/placeholder.svg',
  },
  {
    id: 39,
    name: 'Ingrid K.',
    location: 'Sweden',
    rating: 5,
    text: 'Super fast delivery. I was totally excited and it was exactly what I imagined. Would buy again!',
    avatar: '/placeholder.svg',
  },
  {
    id: 40,
    name: 'Stefan B.',
    location: 'Germany',
    rating: 5,
    text: 'Super card, looks perfect and deceptively real. Even the photo has been integrated very well.',
    avatar: '/placeholder.svg',
  },
  {
    id: 41,
    name: 'Timon V.',
    location: 'Belgium',
    rating: 5,
    text: 'Fast and discrete! Exactly what I needed.',
    avatar: '/placeholder.svg',
  },
  {
    id: 42,
    name: 'Vanessa C.',
    location: 'Brazil',
    rating: 5,
    text: 'Very fast delivery - Top Product! Highly recommended.',
    avatar: '/placeholder.svg',
  },
  {
    id: 43,
    name: 'Yannick F.',
    location: 'France',
    rating: 5,
    text: 'Great products! Fast shipping! Trustworthy service!',
    avatar: '/placeholder.svg',
  },
  {
    id: 44,
    name: 'Ramon G.',
    location: 'Mexico',
    rating: 5,
    text: 'This is a great website and I can only recommend it to everyone!',
    avatar: '/placeholder.svg',
  },
  {
    id: 45,
    name: 'Christoph E.',
    location: 'Germany',
    rating: 5,
    text: 'Top quality, fair prices, very fast delivery time. Perfect!',
    avatar: '/placeholder.svg',
  },
  {
    id: 46,
    name: 'Vivien L.',
    location: 'France',
    rating: 5,
    text: 'On time and perfect! Just love it!',
    avatar: '/placeholder.svg',
  },
  {
    id: 47,
    name: 'Pamela J.',
    location: 'USA',
    rating: 5,
    text: 'Everything worked smoothly. The delivery was very fast!',
    avatar: '/placeholder.svg',
  },
  {
    id: 48,
    name: 'Norbert K.',
    location: 'Poland',
    rating: 5,
    text: 'Very pleased with the rapid settlement of my order! Very satisfied with the service and overall performance.',
    avatar: '/placeholder.svg',
  },
  {
    id: 49,
    name: 'Zoe A.',
    location: 'Australia',
    rating: 5,
    text: 'Easy ordering, fast delivery, good customer service - always happy!',
    avatar: '/placeholder.svg',
  },
  {
    id: 50,
    name: 'Miguel P.',
    location: 'Brazil',
    rating: 5,
    text: 'Best fake ID service I have ever used. Will definitely order again!',
    avatar: '/placeholder.svg',
  },
  {
    id: 51,
    name: 'David K.',
    location: 'Australia',
    rating: 5,
    text: 'Perfect for my themed party. Everyone was impressed with the quality.',
    avatar: '/placeholder.svg',
  },
  {
    id: 52,
    name: 'Tom H.',
    location: 'USA',
    rating: 5,
    text: 'Ordered 10 cards for our team event. All came out perfect!',
    avatar: '/placeholder.svg',
  },
  {
    id: 53,
    name: 'Issa M.',
    location: 'Morocco',
    rating: 5,
    text: 'Good quality and fast shipping. Very professional.',
    avatar: '/placeholder.svg',
  },
  {
    id: 54,
    name: 'Larissa B.',
    location: 'Brazil',
    rating: 5,
    text: 'I love it! Perfect in every way.',
    avatar: '/placeholder.svg',
  },
  {
    id: 55,
    name: 'Angelika S.',
    location: 'Poland',
    rating: 5,
    text: 'Perfect! Exceeded all my expectations.',
    avatar: '/placeholder.svg',
  },
  // Some 4-star reviews for authenticity
  {
    id: 56,
    name: 'Anna S.',
    location: 'Sweden',
    rating: 4,
    text: 'Very happy with my purchase. The customization options are great.',
    avatar: '/placeholder.svg',
  },
  {
    id: 57,
    name: 'Sarah M.',
    location: 'Netherlands',
    rating: 4,
    text: 'Good service, fast shipping to Europe. Minor delay but worth the wait.',
    avatar: '/placeholder.svg',
  },
  {
    id: 58,
    name: 'Henrik L.',
    location: 'Norway',
    rating: 4,
    text: 'Great quality overall. Shipping took a bit longer than expected but the result was worth it.',
    avatar: '/placeholder.svg',
  },
  {
    id: 59,
    name: 'Maria G.',
    location: 'Greece',
    rating: 4,
    text: 'Nice card, good quality. Customer support was helpful when I had questions.',
    avatar: '/placeholder.svg',
  },
  {
    id: 60,
    name: 'Thomas W.',
    location: 'UK',
    rating: 4,
    text: 'Solid product, exactly as described. Would have given 5 stars but delivery was slightly delayed.',
    avatar: '/placeholder.svg',
  },
];
